import { CustomerRow } from '../../CustomersV2.types';

/** Which tab a search result leads to, and how its pill reads. */
export type ResultTab = 'in-progress' | 'decision-ready' | 'declined';

export interface SearchResult {
  row: CustomerRow;
  /** Derived partition/label for this row's pill + destination tab. */
  tab: ResultTab;
}

/**
 * Flatten search results into a single list, tagging each row with the tab it
 * belongs to (mirrors the server-side `view` predicate):
 * - `complete` → decision-ready
 * - `business_details` / `security` → in-progress
 * - `declined` → its own `declined` pill (opens a modal rather than a tab)
 *
 * Search sends no `view`, so declined buyers surface here whatever the seller's
 * "View declined customers" setting is — unlike the tab tables.
 */
export const deriveResultRows = (rows: CustomerRow[]): SearchResult[] =>
  rows.map((row) => ({ row, tab: tabForStage(row.application_stage.value) }));

const tabForStage = (stage: string): ResultTab => {
  if (stage === 'complete') return 'decision-ready';
  if (stage === 'declined') return 'declined';
  return 'in-progress';
};
